/**
 * Wishlist Logic for SHINE
 * Uses localStorage to persist saved items across sessions.
 */

const WISHLIST_KEY = 'shine_wishlist';

function getWishlist() {
  const data = localStorage.getItem(WISHLIST_KEY);
  return data ? JSON.parse(data) : [];
}

function saveWishlist(wishlist) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  updateWishlistUI();
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
}

function toggleWishlist(handle) {
  let wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  if (index === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(index, 1);
  }
  saveWishlist(wishlist);
  return index === -1; // returns true if added
}

function isInWishlist(handle) {
  return getWishlist().includes(handle);
}

function updateWishlistUI() {
  const count = getWishlist().length;
  document.querySelectorAll('.wishlist-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });

  // Update buttons
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    const handle = btn.dataset.wishlistToggle;
    const isActive = isInWishlist(handle);
    btn.classList.toggle('is-active', isActive);

    const icon = btn.querySelector('svg');
    if (icon) {
      if (isActive) {
        icon.setAttribute('fill', 'currentColor');
        icon.classList.add('text-mocha');
      } else {
        icon.setAttribute('fill', 'none');
        icon.classList.remove('text-mocha');
      }
    }
  });
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  updateWishlistUI();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      const handle = btn.dataset.wishlistToggle;
      toggleWishlist(handle);
    }
  });
});

window.wishlist = { get: getWishlist, toggle: toggleWishlist, isIn: isInWishlist, updateUI: updateWishlistUI };
